import { InsetBaySetting } from "./InsetBaySetting";
import { Collection } from "../utils/Collection";

export class InsetBayConfig
{
    private _label;
    private _orderId;
    private _count;
    private _length;
    //private _drop;
    //private _overhang;
    private _fields;

    public back : InsetBaySetting;
    public front: InsetBaySetting;

    constructor(config:any)
    {
        this._label = config.label;
        this._orderId = config.orderId;
        this._count = config.count;
        this._length = config.length;
        //this._drop = config.drop;
        //this._overhang = config.overhang;

        this._fields = new Collection(config.fields, "id");

        this.back  = new InsetBaySetting(config);
        this.front = new InsetBaySetting(config);
    }

    public get label()
    {
        return this._label;
    }
    public get orderId()
    {
        return this._orderId;
    }
    public get count()
    {
        return this._count;
    }
    public get length()
    {
        return this._length;
    }
    /*public get drop()
    {
        return this._drop;
    }*/
    public get fields()
    {
        return this._fields;
    }
}